import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import _defineProperty from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import QSpinner from "../components/spinner/QSpinner.js";
import { isSSR } from "./Platform.js";
import cache from "../utils/cache.js";
import { preventScroll } from "../mixins/prevent-scroll.js";
var vm,
    uid = 0,
    timeout,
    props = {};

var originalDefaults = {
  delay: 0,
  message: false,
  spinnerSize: 80,
  spinnerColor: 'white',
  messageColor: 'white',
  backgroundColor: 'black',
  spinner: QSpinner,
  customClass: ''
},
    defaults = _objectSpread({}, originalDefaults);

var Loading = {
  isActive: false,
  show: function show(opts) {
    var _this = this;

    if (isSSR === true) {
      return;
    }

    props = opts === Object(opts) && opts.ignoreDefaults === true ? _objectSpread(_objectSpread({}, originalDefaults), opts) : _objectSpread(_objectSpread({}, defaults), opts);
    props.customClass += " text-".concat(props.backgroundColor);
    props.uid = "l_".concat(uid++);
    this.isActive = true;

    if (vm !== void 0) {
      vm.$forceUpdate();
      return;
    }

    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = void 0;
      var node = document.createElement('div');
      document.body.appendChild(node);
      vm = new Vue({
        name: 'QLoading',
        el: node,
        mounted: function mounted() {
          preventScroll(true);
        },
        render: function render(h) {
          return h('transition', {
            props: {
              name: 'q-transition--fade',
              appear: true
            },
            on: cache(_this, 'tr', {
              'after-leave': function afterLeave() {
                // might be called to finalize
                // previous leave, even if it was cancelled
                if (_this.isActive !== true && vm !== void 0) {
                  preventScroll(false);
                  vm.$destroy();
                  vm.$el.remove();
                  vm = void 0;
                }
              }
            })
          }, [_this.isActive === true ? h('div', {
            staticClass: 'q-loading fullscreen column flex-center z-max',
            key: props.uid,
            class: props.customClass.trim()
          }, [h(props.spinner, {
            props: {
              color: props.spinnerColor,
              size: props.spinnerSize
            }
          }), props.message && h('div', {
            class: "text-".concat(props.messageColor),
            domProps: _defineProperty({}, props.sanitize === true ? 'textContent' : 'innerHTML', props.message)
          }) || void 0]) : null]);
        }
      });
    }, props.delay);
  },
  hide: function hide() {
    if (this.isActive === true) {
      if (timeout !== void 0) {
        clearTimeout(timeout);
        timeout = void 0;
      }

      this.isActive = false;
    }
  },
  setDefaults: function setDefaults(opts) {
    opts === Object(opts) && Object.assign(defaults, opts);
  },
  install: function install(_ref) {
    var $q = _ref.$q,
        loading = _ref.cfg.loading;
    this.setDefaults(loading);
    $q.loading = this;
  }
};

if (isSSR === false) {
  Vue.util.defineReactive(Loading, 'isActive', Loading.isActive);
}

export default Loading;